export const SUPPORTED_LOCALES = ['it', 'en'];

export const FALLBACK_LOCALE = 'en';
